<template>
  <div>
    <h2>Operacje</h2>
    <v-row v-if="company">
      <v-col>
        Wdrożenie: {{company.name}}
      </v-col>
    </v-row>
    <data-table :items="operations" :headers="headers" @click:row="detailsDialog=true; detailsOperation = $event">
      <template v-slot:item.actions="{item}">
        <v-tooltip top>
          <template v-slot:activator="{on, attrs}">
            <v-btn v-bind="attrs" v-on="on" class="mr-2" @click="$router.push(companyId +'/Slots/' + item.id)">
              <v-icon small>fas fa-clipboard-list</v-icon>
            </v-btn>
          </template>
          Sloty
        </v-tooltip>
      </template>
    </data-table>
    <v-dialog v-model="detailsDialog" :width="800">
      <v-card v-if="detailsOperation">
        <v-card-title>
          Szczegóły operacji
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
                Id: {{detailsOperation.id}}
            </v-col>
            <v-col>
              Id kolejki w WebAdmin: {{detailsOperation.queueId}}
            </v-col>
            <v-col>Id operacji w WebAdmin: {{detailsOperation.operationId}}</v-col>
          </v-row>
          <v-row>
            <v-col>Nazwa kolejki: {{detailsOperation.queueName}}</v-col>
            <v-col>Nazwa operacji: {{detailsOperation.operationName}}</v-col>
            <v-col>Aktualny bilet: {{detailsOperation.currentTicket}}</v-col>
          </v-row>
          <v-row>
            <v-col>
              Oczekujących: {{detailsOperation.waitingCount}}
            </v-col>
            <v-col>
              Stanowisk w operacji: {{detailsOperation.workingStands}}
            </v-col>
            <v-col>
              Stanowisk w kolejce: {{detailsOperation.queueWorkingStands}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Obsłużonych: {{detailsOperation.servedCount}}
            </v-col>
            <v-col>
              Aktywna rezerwacja: {{detailsOperation.isReservationActive}}
            </v-col>
            <v-col>
              Aktywny podglad kolejek: {{detailsOperation.isStatusActive}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Data utworzenia: {{moment(detailsOperation.createDateTime).format("YYYY-MM-DD HH:mm:ss")}}
            </v-col>
            <v-col>
              Ostatnia aktualizacja: {{moment(detailsOperation.lastUpdateDateTime).format("YYYY-MM-DD HH:mm:ss")}}
            </v-col>
            <v-col>
              Możliwość anulowania rezerwacji: {{detailsOperation.canCancelReservation}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Dni do wyświetlenia: {{detailsOperation.daysToDisplay}}
            </v-col>
            <v-col>
              Przesunięcie godzinowe: {{detailsOperation.webFromDayOffset}}
            </v-col>
            <v-col>
              Unikatowe rezerwacje: {{detailsOperation.uniquePropertiesCount}}
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              Unikatowe rezerwacje na całym horyzoncie czasowym: {{detailsOperation.uniquePropertiesForAllDate}}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      detailsDialog: false,
      detailsOperation: null,
      headers:[
        {
          text:'Id',
          value: 'id'
        },
        {
          text:"WebAdminOpId",
          value:"operationId"
        },
        {
          text:"WebAdminQueueId",
          value:"queueId"
        },
        {
          text:'Nazwa operacji',
          value:"operationName"
        },
        {
          text:"Nazwa kolejki",
          value:"queueName"
        },
        {
          text: "Opcje",
          value:"actions"
        }
      ],
      operations: [],
      company: null
    }
  },
  computed: {
    companyId() {
      return this.$route.params.companyId;
    }
  },
  mounted() {
    let vm = this;
    vm.$http.get("Company/GetCompany?id=" + vm.companyId).then(response=>{
      vm.company = response.data;
      vm.$http.get("Operation/GetCompanyOperations?companyId=" + vm.companyId).then(response => {
        vm.operations = response.data;
      })
    })
  }
}
</script>
